module.exports = __webpack_public_path__ + "static/media/3.c13dff8c.jpg";